import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "m-popover-template",
  ref: "popoverElementRef"
}
const _hoisted_2 = { class: "m-popover" }
const _hoisted_3 = {
  key: 0,
  class: "m-popover-title"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(_ctx.title), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass(`m-popover-body ${_ctx.className}`)
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2 /* CLASS */)
    ]),
    _hoisted_4
  ], 512 /* NEED_PATCH */)), [
    [_vShow, _ctx.showPopover]
  ])
}